var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { IconChevronDown, IconClose, IconChevronTop } from "../../icons";
import Typography from "../Typography";
import PropTypes from "prop-types";
import classnames from "classnames";
export var Select = function (_a) {
    var _b, _c;
    var children = _a.children, _d = _a.placeholder, placeholder = _d === void 0 ? "Select" : _d, options = _a.options, _e = _a.multiple, multiple = _e === void 0 ? false : _e, _f = _a.searchable, searchable = _f === void 0 ? false : _f, value = _a.value, rightIcon = _a.rightIcon, leftIcon = _a.leftIcon, open = _a.open, onChange = _a.onChange, onVisibleChange = _a.onVisibleChange, _g = _a.trigger, trigger = _g === void 0 ? "click" : _g, _h = _a.className, className = _h === void 0 ? "" : _h, _j = _a.searchPlaceholder, searchPlaceholder = _j === void 0 ? "" : _j, defaultValue = _a.defaultValue, customLabel = _a.customLabel, _k = _a.disabled, disabled = _k === void 0 ? false : _k, otherProps = __rest(_a, ["children", "placeholder", "options", "multiple", "searchable", "value", "rightIcon", "leftIcon", "open", "onChange", "onVisibleChange", "trigger", "className", "searchPlaceholder", "defaultValue", "customLabel", "disabled"]);
    var _l = useState(false), showMenu = _l[0], setShowMenu = _l[1];
    var _m = useState([]), selectedValue = _m[0], setSelectedValue = _m[1];
    var _o = useState(""), searchValue = _o[0], setSearchValue = _o[1];
    var _p = useState(false), mouseOverButton = _p[0], setMouseOverButton = _p[1];
    var _q = useState(false), mouseOverMenu = _q[0], setMouseOverMenu = _q[1];
    var searchRef = React.createRef();
    var inputRef = React.createRef();
    var wrapperRef = React.createRef();
    var timeoutLength = 500;
    var enterButton = function () {
        setMouseOverButton(true);
    };
    var leaveButton = function () {
        setTimeout(function () {
            setMouseOverButton(false);
        }, timeoutLength);
    };
    var enterMenu = function () {
        setMouseOverMenu(true);
    };
    var leaveMenu = function () {
        setTimeout(function () {
            setMouseOverMenu(false);
        }, timeoutLength);
    };
    var classNames = classnames((_b = {},
        _b["mex-select__wrapper"] = true,
        _b[className] = className,
        _b));
    useEffect(function () {
        var handler = function (e) {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setShowMenu(false);
            }
        };
        window.addEventListener("mousedown", handler);
        return function () {
            window.removeEventListener("mousedown", handler);
        };
    });
    useEffect(function () {
        var newValue = value || defaultValue;
        var newSelectedOptions = options.filter(function (option) {
            return Array.isArray(newValue)
                ? newValue === null || newValue === void 0 ? void 0 : newValue.includes(typeof option.value === "number" ? option.value.toString() : option.value)
                : newValue === (typeof option.value === "number" ? option.value.toString() : option.value);
        });
        setSelectedValue(newSelectedOptions);
    }, [value, defaultValue, options]);
    useEffect(function () {
        setSearchValue("");
        if (showMenu && searchRef.current) {
            searchRef.current.focus();
        }
    }, [showMenu]);
    var handleInputClick = function () {
        if (onVisibleChange)
            onVisibleChange(!showMenu);
        setShowMenu(!showMenu);
    };
    var getDisplay = function () {
        if (!selectedValue || selectedValue.length === 0) {
            return placeholder;
        }
        if (multiple) {
            return (_jsx("div", __assign({ className: "mex-select__tags" }, { children: selectedValue.map(function (option) { return (_jsxs("div", __assign({ className: "mex-select__tag-item" }, { children: [option.leftIcon, option.label, _jsx("span", __assign({ onClick: function (e) { return onTagRemove(e, option); }, className: "mex-select__tag-close" }, { children: _jsx(IconClose, {}) })), option.rightIcon] }), option.key || option.value)); }) })));
        }
        else {
            if (customLabel) {
                var value_1 = Array.isArray(selectedValue) ? selectedValue[0].value : selectedValue.value;
                return customLabel(typeof value_1 == "number" ? value_1.toString() : value_1);
            }
            return Array.isArray(selectedValue) ? selectedValue[0].label : selectedValue.label;
        }
    };
    var removeOption = function (option) {
        return selectedValue.filter(function (o) { return o.value !== option.value; });
    };
    var onTagRemove = function (e, option) {
        e.stopPropagation();
        var newValue = removeOption(option);
        setSelectedValue(newValue);
        if (onChange)
            onChange(newValue.value);
    };
    var onItemClick = function (option) {
        var newValue;
        if (multiple) {
            if (selectedValue.findIndex(function (o) { return o.value === option.value; }) >= 0) {
                newValue = removeOption(option);
            }
            else {
                if (Array.isArray(selectedValue)) {
                    newValue = __spreadArray(__spreadArray([], selectedValue, true), [option], false);
                }
            }
        }
        else {
            newValue = option;
        }
        setSelectedValue(newValue);
        if (onChange)
            onChange(newValue.value);
    };
    var isSelected = function (option) {
        if (multiple) {
            return selectedValue.filter(function (o) { return o.value === option.value; }).length > 0;
        }
        if (!selectedValue || selectedValue.length === 0) {
            return false;
        }
        return Array.isArray(selectedValue)
            ? option.value === selectedValue[0].value
            : selectedValue.value === option.value;
    };
    var onSearch = function (e) {
        setSearchValue(e.target.value);
    };
    var getOptions = function () {
        if (!searchValue) {
            return options;
        }
        return options.filter(function (option) { return option.label.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0; });
    };
    var isOpen = showMenu || mouseOverButton || mouseOverMenu;
    useEffect(function () {
        if (open)
            setShowMenu(true);
    }, [open]);
    var containerClassNames = classnames((_c = {},
        _c["mex-select__container"] = true,
        _c["mex-select__container--selected"] = selectedValue.length != 0,
        _c["mex-select__container--disabled"] = disabled,
        _c));
    var chevronColor = { color: "#A3A3A3" };
    return (_jsx(React.Fragment, { children: _jsxs("div", __assign({ className: classNames, ref: wrapperRef }, { children: [children && (_jsx("div", __assign({ className: "mex-select__label" }, { children: _jsx(Typography, __assign({ variant: "body02Regular" }, { children: children })) }))), _jsxs("div", __assign({ className: containerClassNames, onClick: function (e) {
                        e.stopPropagation();
                    } }, otherProps, { children: [_jsxs("div", __assign({ ref: inputRef }, (trigger === "click" && {
                            onClick: function () {
                                handleInputClick();
                            },
                        }), (trigger === "hover" && {
                            onMouseEnter: function () {
                                enterButton();
                            },
                            onMouseLeave: function () {
                                leaveButton();
                            },
                        }), { onClick: handleInputClick, className: "mex-select__input" }, { children: [leftIcon && leftIcon, _jsx("div", __assign({ className: "mex-select__selected-value" }, { children: _jsx(Typography, __assign({ variant: "body02Regular" }, { children: getDisplay() })) })), !rightIcon ? (_jsx("div", __assign({ className: "mex-select__tool" }, { children: !disabled && showMenu ? (_jsx(IconChevronTop, { style: chevronColor })) : (_jsx(IconChevronDown, { style: chevronColor })) }))) : (rightIcon)] })), !disabled && isOpen && (_jsx("div", { children: _jsxs("div", __assign({ className: "mex-select__menu" }, (trigger === "hover" && {
                                onMouseEnter: function () {
                                    enterMenu();
                                },
                                onMouseLeave: function () {
                                    leaveMenu();
                                },
                            }), { children: [searchable && (_jsx("div", __assign({ className: "mex-select__search-box" }, { children: _jsx("input", { onChange: onSearch, value: searchValue, ref: searchRef, placeholder: searchPlaceholder }) }))), getOptions().map(function (option, index) { return (_jsx("div", __assign({ onClick: function () {
                                            if (option.onChange)
                                                option.onChange(option);
                                            onItemClick(option);
                                        }, tabIndex: index + 1, className: "mex-select__item ".concat(isSelected(option) ? "mex-select__selected" : ""), id: option.id ? option.id : "mexdsSelectItemId".concat(option.value), onKeyDown: function (e) {
                                            var _a, _b, _c, _d, _e;
                                            if ((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.classList.contains("mex-select__item")) {
                                                if (e.key === "ArrowUp")
                                                    (_b = e.currentTarget.previousElementSibling) === null || _b === void 0 ? void 0 : _b.focus();
                                                if (e.key === "ArrowDown")
                                                    (_c = e.currentTarget.nextElementSibling) === null || _c === void 0 ? void 0 : _c.focus();
                                                if (e.key === "ArrowLeft")
                                                    (_d = e.currentTarget.previousElementSibling) === null || _d === void 0 ? void 0 : _d.focus();
                                                if (e.key === "ArrowRight")
                                                    (_e = e.currentTarget.nextElementSibling) === null || _e === void 0 ? void 0 : _e.focus();
                                            }
                                        } }, { children: option.customItem ? (_jsx("div", __assign({ id: option.id ? option.id : "mexdsSelectItemId".concat(option.value) }, { children: option.customItem }))) : (option.label &&
                                            option.value && (_jsx("div", { children: _jsxs("div", __assign({ className: "mex-select__item--label" }, { children: [option.leftIcon, _jsx("span", __assign({ className: isSelected(option) ? "mex-select__selected-font" : "" }, { children: option.label })), option.rightIcon && option.rightIcon] })) }))) }), option.value)); })] })) }))] }))] })) }));
};
Select.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    placeholder: PropTypes.string,
    options: PropTypes.array,
    multiple: PropTypes.bool,
    searchable: PropTypes.bool,
    rightIcon: PropTypes.node,
    leftIcon: PropTypes.node,
    onChange: PropTypes.func,
    open: PropTypes.bool,
    disabled: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    className: PropTypes.string,
    trigger: PropTypes.oneOf(["click", "hover"]),
    customLabel: PropTypes.func,
};
Select.defaultProps = {
    placeholder: "Select",
    trigger: "click",
};
export default Select;
